(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("core-utils"), require("microkernel"), require("core-vendor"));
	else if(typeof define === 'function' && define.amd)
		define("core-application", ["core-utils", "microkernel", "core-vendor"], factory);
	else if(typeof exports === 'object')
		exports["core-application"] = factory(require("core-utils"), require("microkernel"), require("core-vendor"));
	else
		root["core-application"] = factory(root["core-utils"], root["microkernel"], root["core-vendor"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__8717__, __WEBPACK_EXTERNAL_MODULE__2168__, __WEBPACK_EXTERNAL_MODULE__9164__) {
return 